import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApiSchemaCompany } from "../../../models/api/company";

interface ICompanySlice {
  company?: ApiSchemaCompany;
  subscribed?: boolean;
}

const initialState: ICompanySlice = {
  company: undefined,
  subscribed: true,
};

const sliceCompany = createSlice({
  initialState,
  name: "sliceCompany",
  reducers: {
    setCompany(state, action: PayloadAction<ApiSchemaCompany>) {
      state.company = action.payload;
    },
    setSubscribed(state, action: PayloadAction<boolean>) {
      state.subscribed = action.payload;
    },
  },
});

export const ReducerCompany = sliceCompany.reducer;
export const ActionCompany = sliceCompany.actions;
